import React, { useMemo, useState, useEffect, useRef } from "react";
import { OrderStatusConstants, InvoiceConstants } from "../../common/constants";
import { useTranslation } from "react-i18next";
import AppTable from "../orderStatus/AppTable";
import InvoicesFilter from "./InvoicesFilter";
import InvoiceSummary from "./InvoiceSummary";
import PayCheckedInvoices from "./PayCheckedInvoices";
import CustomPopupDialog from "../../components/global/CustomPopupDialog/CustomPopupDialog";
import ChequePaymentWarningPopup from "./ChequePaymentWarningPopup";
import useSelectPaymentMethod from "../../hooks/useSelectPaymentMethod";
import moment from "moment";
import Pagination from "../orderStatus/Pagination";
import { useDispatch, useSelector } from "react-redux";
import {
  GetInvoiceDetailsByInvoiceID,
  GetInvoiceTotalsByInvoiceID,
  invoiceSelector,
  setInvoiceFilterValue,
  setSelectedOutstandingInvoices,
} from "../../features/invoice/invoiceSlice";
import Loader from "../orderStatus/Loader";
import parse from "html-react-parser";
import { lawFirmSelector } from "../../features/lawFirm/lawFirmSlice";

const OutstandingInvoices = ({
  setshowOutstanding,
  setIsPayInvoices,
  getOutstandingInvoices,
  firmID,
  userId,
  isLawyer,
  setShowInvoiceSummary,
  showInvoiceSummary,
  setspayCheckedInvoices,
  payCheckedInvoices,
  isInternalUser,
  firmIDAndName,
  DashboardLawfirm,
}) => {
  const isFirstRender = useRef(true);
  const [invoiceSummary, setinvoiceSummary] = useState(null);
  const [ChequePaymentWarning, setChequePaymentWarning] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const {
    firmInvoices,
    lawyerFilterOptions,
    firmInvoicesTotal,
    loadingInvoice,
  } = useSelector(invoiceSelector);
  const [ordersPerPage, setOrdersPerPage] = useState(0);
  const dispatch = useDispatch();
  // const [filteredData, setFilteredData] = useState([]);
  const { lawyersByFirm } = useSelector(lawFirmSelector);

  useEffect(() => {
    setOrdersPerPage(firmInvoices?.length);
  }, [firmInvoices]);

  const columns = (userLogin, t) => {
    //const { t } = useTranslation();
    return !isLawyer
      ? [
        {
          Header: t("InvoiceNo"),
          accessor: "invoiceID",
          width: 30,
          sortable: true,
          Cell: ({ row }) => {
            //spread the props

            return (
              <div className="ml-3 w-max">
                <button
                  className="text-secondary-blue"
                  onClick={() => {
                    dispatch(
                      GetInvoiceDetailsByInvoiceID(row.original.invoiceID),
                    );
                    dispatch(
                      GetInvoiceTotalsByInvoiceID(row.original.invoiceID),
                    );
                    setinvoiceSummary(row);
                    setselectedOutstandingInvoices([row]);
                    setShowInvoiceSummary(true);
                  }}
                >
                  {row.original.invoiceID}
                </button>
                <br />
              </div>
            );
          },
        },
        {
          Header: t("OrderNo"),
          accessor: "fileID",
          width: 30,
          sortable: true,
          Cell: ({ row }) => {
            //spread the props

            return (
              <div className="ml-3">
                <button className="fileNumber text-secondary-blue">
                  {row.original.fileNumber}
                </button>
                <br />
                <span className="internalReference">
                  {row.original.internalReference}
                </span>
              </div>
            );
          },
        },
        {
          Header: t("file/reference"),
          accessor: "referenceNumber",
          width: 0,
          sortable: true,
        },
        // {
        //   Header: "overdue",
        //   accessor: "OverDueDays",
        //   width: 0,
        // },
        {
          Header: t("LawyerName"),
          accessor: "lawyerName",
          width: 100,
          sortable: true,
        },
        {
          Header: t("ClientName"),
          accessor: "clients",
          width: 140,
        },
        {
          Header: t("PropertyAddress"),
          accessor: "propertyAddress",
          width: 350,
          itemsToShow: 3,
          expanded: false,
          Cell: ({ row }) => {
            return parse(row?.original?.propertyAddress);
          },
        },
        {
          Header: t("DealType"),
          accessor: "dealType",
          width: 100,
          sortable: true,
        },
        {
          Header: t("BillingType"),
          accessor: "billingType",
          width: 200,
          sortable: true,
        },
        {
          Header: "cardNumber",
          accessor: "cardNumber",
          width: 10,
          // sortable: true,
        },
        {
          Header: t("ClosingDate"),
          accessor: "closingDate",
          width: 200,
        },
        {
          Header: t("NetDue"),
          accessor: "total",
          width: 100,
          sortable: true,
          Cell: ({ row }) => {
            //spread the props

            return (
              <div className="ml-3 w-max">
                <span className="">{row.original.invoiceTotal}</span>
                <br />
                {row.original.overDueLabel && (
                  <span className="float-right text-[10px] text-secondary-red">
                    {row.original.overDueLabel}
                  </span>
                )}
              </div>
            );
          },
        },
      ]
      : [
        {
          Header: t("InvoiceNo"),
          accessor: "invoiceID",
          width: 30,
          sortable: true,
          Cell: ({ row }) => {
            //spread the props

            return (
              <div className="ml-3 w-max">
                <button
                  className="text-secondary-blue"
                  onClick={() => {
                    dispatch(
                      GetInvoiceDetailsByInvoiceID(row.original.invoiceID),
                    );
                    dispatch(
                      GetInvoiceTotalsByInvoiceID(row.original.invoiceID),
                    );
                    setinvoiceSummary(row);
                    setselectedOutstandingInvoices([row]);
                    setShowInvoiceSummary(true);
                  }}
                >
                  {row.original.invoiceID}
                </button>
                <br />
              </div>
            );
          },
        },
        {
          Header: t("OrderNo"),
          accessor: "fileID",
          width: 30,
          sortable: true,
          Cell: ({ row }) => {
            //spread the props

            return (
              <div className="ml-3">
                <button className="fileNumber text-secondary-blue">
                  {row.original.fileNumber}
                </button>
                <br />
                <span className="internalReference">
                  {row.original.internalReference}
                </span>
              </div>
            );
          },
        },
        {
          Header: t("file/reference"),
          accessor: "referenceNumber",
          width: 0,
          sortable: true,
        },
        // {
        //   Header: "overdue",
        //   accessor: "OverDueDays",
        //   width: 0,
        // },
        {
          Header: t("ClientName"),
          accessor: "clients",
          width: 140,
        },
        {
          Header: t("PropertyAddress"),
          accessor: "propertyAddress",
          width: 350,
          itemsToShow: 3,
          expanded: false,
          Cell: ({ row }) => {
            return parse(row?.original?.propertyAddress);
          },
        },
        {
          Header: t("DealType"),
          accessor: "dealType",
          width: 100,
          sortable: true,
        },
        {
          Header: t("BillingType"),
          accessor: "billingType",
          width: 200,
          sortable: true,
        },
        {
          Header: "cardNumber",
          accessor: "cardNumber",
          width: 10,
          // sortable: true,
        },
        {
          Header: t("ClosingDate"),
          accessor: "closingDate",
          width: 200,
        },
        {
          Header: t("NetDue"),
          accessor: "total",
          width: 100,
          sortable: true,
          Cell: ({ row }) => {
            //spread the props

            return (
              <div className="ml-3 w-max">
                <span className="">{row.original.invoiceTotal}</span>
                <br />
                {row.original.overDueLabel && (
                  <span className="float-right text-[10px] text-secondary-red">
                    {row.original.overDueLabel}
                  </span>
                )}
              </div>
            );
          },
        },
      ];
  };

  const [pageData, setPageData] = useState({
    rowData: [],
    isLoading: false,
    totalPages: Math.ceil(
      firmInvoices &&
      firmInvoices?.length > 0 &&
      firmInvoices[0]?.totalRows / ordersPerPage,
    ),
    totalOrders:
      (firmInvoices &&
        firmInvoices?.length > 0 &&
        firmInvoices[0]?.totalRows) ||
      0,
    column: null,
    order: "ascending",
  });
  const [column, setColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("ascending");
  const [filterValues, setFilterValues] = useState([]);
  const [selectedOutstandingInvoices, setselectedOutstandingInvoices] =
    useState([]);
  const { cheque, eft, creditCard } = useSelectPaymentMethod(
    selectedOutstandingInvoices,
  );

  const onFilter = (page) => {
    getOutstandingInvoices({
      FirmID: firmID,
      Paid: false,
      userID: userId,
      commercial: filterValues.DealType || 2,
      Lawyer: filterValues.LawyerName || "",
      // closeDate: (!Array.isArray(filterValues?.closingDate) && moment(filterValues?.closingDate).format("DD/MM/YYYY")) || "",
      DateRangeStart:
        (Array.isArray(filterValues?.closingDate) &&
          filterValues.closingDate?.length > 0 &&
          filterValues.closingDate[0] !== "" &&
          moment(filterValues.closingDate[0]).format("DD/MM/YYYY")) ||
        "",
      DateRangeEnd:
        (Array.isArray(filterValues?.closingDate) &&
          filterValues.closingDate?.length > 0 &&
          filterValues.closingDate[0] !== "" &&
          moment(filterValues.closingDate[1]).format("DD/MM/YYYY")) ||
        "",
      BillingType: filterValues.paymentMethod || "",
      SelectedFilelanguage: "",
      SearchText: filterValues?.search || "",
      SortColumn: column || "",
      SortOrder:
        sortOrder === "ascending"
          ? "asc"
          : sortOrder === "descending"
            ? "desc"
            : "",
      TotalRangeStart:
        filterValues?.rangeValue?.length > 0 ? filterValues?.rangeValue[0] : "",
      TotalRangeEnd:
        filterValues?.rangeValue?.length > 0 ? filterValues?.rangeValue[1] : "",
      pageNumber: page || currentPage || 1,
    });
    dispatch(setInvoiceFilterValue(["OutstandingFilters", filterValues]));
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setCurrentPage(0);
    onFilter(1);
  }, [filterValues, sortOrder, column]);

  useEffect(() => {
    setPageData((prevState) => ({
      ...prevState,
      rowData: [],
      isLoading: true,
    }));
    const startIndex = (currentPage - 1) * ordersPerPage;
    const endIndex = startIndex + ordersPerPage;
    const data = firmInvoices;
    setPageData({
      isLoading: false,
      rowData: data,
      totalPages: Math.ceil(
        firmInvoices &&
        firmInvoices?.length > 0 &&
        firmInvoices[0]?.totalRows / ordersPerPage,
      ),
      totalOrders:
        (firmInvoices &&
          firmInvoices?.length > 0 &&
          firmInvoices[0]?.totalRows) ||
        0,
    });
  }, [
    firmInvoices,
    currentPage,
    pageData.column,
    pageData.order,
    filterValues,
  ]);

  const onSort = (column, order) => {
    setColumn(column);
    setSortOrder(order);
    setPageData((prevState) => ({
      ...prevState,
      column,
      order,
    }));
  };

  const { t } = useTranslation();

  const DealTypeOptions = OrderStatusConstants?.DealTypeNumericOptions?.sort(
    (a, b) => a.label.localeCompare(b.label),
  ).map((item, i) => {
    return { label: t(item.label), value: item.value };
  });
  const StatusOptions = OrderStatusConstants.StatusOptions.map((item, i) => {
    return { label: t(item.label), value: item.value };
  });
  const LawyerOptions = [
    { label: "All", value: "All" },
    ...(lawyerFilterOptions?.map((item) => ({
      label: t(item.lawyerWithActive),
      value: item.userId,
    })) || []),
  ];
  const PaymentMethodOptions = InvoiceConstants.PaymentMethodOptions.map(
    (item, i) => {
      return { label: t(item.label), value: item.value };
    },
  );

  const [LawyerOptionsByFirm, setLawyerOptionsbyFirm] = useState([]);

  useEffect(() => {
    if (lawyerFilterOptions === undefined || lawyerFilterOptions === null || lawyerFilterOptions?.length === 0) {
      let lawyeroptions = [];
      lawyeroptions.push({ label: t('All'), value: "All" });
      lawyersByFirm?.lawyers?.map((item, i) => {
        lawyeroptions.push({ label: t(item.lawyer), value: item.userID });
      });
      setLawyerOptionsbyFirm(lawyeroptions);
    }

  }, [lawyersByFirm]);

  return (
    <div>
      {!invoiceSummary && !payCheckedInvoices && (
        <div>
          <InvoicesFilter
            DealTypeOptions={DealTypeOptions}
            LawyerOptions={lawyerFilterOptions?.length ? LawyerOptions : LawyerOptionsByFirm}
            StatusOptions={StatusOptions}
            onFilter={(values) => {
              if (isFirstRender.current) {
                isFirstRender.current = false;
                return;
              }
              setFilterValues((prev) => ({ ...prev, ...values }));
              // setCurrentPage(0);
            }}
            cheque={cheque}
            eft={eft}
            selectedOutstandingInvoices={selectedOutstandingInvoices}
            setspayCheckedInvoices={(data) => {
              setspayCheckedInvoices(data);
              setIsPayInvoices(data);
            }}
            setChequePaymentWarning={setChequePaymentWarning}
            PaymentMethodOptions={PaymentMethodOptions}
            isLawyer={isLawyer}
            firmId={firmID}
            userId={userId}
            isInternalUser={isInternalUser}
          />

          <div style={{ height: "auto" }}>
            {firmInvoices?.length > 0 && (
              <AppTable
                columns={columns}
                data={pageData.rowData || []}
                isLoading={pageData.isLoading}
                onSort={onSort}
                manualSorting
                pickupInvoice
                setSelectedRows={(rows) => {
                  setselectedOutstandingInvoices(rows);
                  dispatch(
                    setSelectedOutstandingInvoices(
                      rows?.map((item) => item.original),
                    ),
                  );
                }}
              />
            )}
          </div>
          <br />
          {!pageData.rowData || pageData?.rowData?.length === 0 &&
            <div className="text-center text-secondary-red font-semibold text-lg">
              {t('noResults')}
            </div>
          }
          <div>
            {
              // outstandingInvoices && outstandingInvoices?.length > 0 && (
              <Pagination
                totalRows={pageData?.totalOrders}
                pageChangeHandler={(page) => {
                  setCurrentPage(page);
                  onFilter(page + 1);
                }}
                rowsPerPage={ordersPerPage}
                currentPage={currentPage}
                outstandingInvoices
              />
              // )
            }
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <div
              className="mb-4"
              style={{
                fontFamily: "Arial, sans-serif",
                maxWidth: "700px",
                padding: "20px",
                border: "1px solid #ccc",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                }}
              >
                <span style={{ marginRight: "40px" }}>Sub-Total:</span>
                <span>{firmInvoicesTotal?.invoiceSubTotal}</span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                }}
              >
                <span style={{ marginRight: "40px" }}>
                  Less Encompass Home Warranty Fee:
                </span>

                <span> {firmInvoicesTotal?.encompassHomeWarrantyFeeTotal}</span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                }}
              >
                <span style={{ marginRight: "40px" }}>
                  Less Elite Fee for service:
                </span>
                <span> {firmInvoicesTotal?.invoiceEliteFeeTotal}</span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                }}
              >
                <span style={{ marginRight: "40px" }}>Tax:</span>
                <span>{firmInvoicesTotal?.invoiceTax}</span>
              </div>
              <hr />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                }}
              >
                <span style={{ marginRight: "40px" }}>
                  Total Outstanding Amount:
                </span>
                <span> {firmInvoicesTotal?.invoicetotal}</span>
              </div>
            </div>
          </div>
        </div>
      )}
      {ChequePaymentWarning && (
        <CustomPopupDialog
          component={
            <ChequePaymentWarningPopup
              setChequePaymentWarning={setChequePaymentWarning}
              setspayCheckedInvoices={setspayCheckedInvoices}
            />
          }
        />
      )}
      {showInvoiceSummary && (
        <InvoiceSummary
          setinvoiceSummary={setinvoiceSummary}
          invoiceDetails={invoiceSummary}
          setspayCheckedInvoices={(val) => setspayCheckedInvoices(val)}
          setShowInvoiceSummary={(val) => setShowInvoiceSummary(val)}
          t={t}
        />
      )}
      {payCheckedInvoices && !ChequePaymentWarning && (
        <PayCheckedInvoices
          cheque={cheque}
          eft={eft}
          creditCard={creditCard}
          selectedOutstandingInvoices={
            selectedOutstandingInvoices || invoiceSummary
          }
          setspayCheckedInvoices={(data) => {
            setspayCheckedInvoices(data);
            setIsPayInvoices(data);
          }}
          isLawyer={isLawyer}
          setshowOutstanding={setshowOutstanding}
          firmID={firmID}
        />
      )}
      {loadingInvoice ? <Loader /> : ""}
    </div>
  );
};

export default OutstandingInvoices;
